import { render, staticRenderFns } from "./AppointmentEditForm.vue?vue&type=template&id=e0b5172c"
import script from "./AppointmentEditForm.vue?vue&type=script&lang=ts"
export * from "./AppointmentEditForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports